// extracted by mini-css-extract-plugin
export var adressMap = "index-module--adressMap--b2724";
export var border = "index-module--border--b759c";
export var column = "index-module--column--7f7de";
export var content = "index-module--content--2f01a";
export var position = "index-module--position--994f8";
export var row = "index-module--row--8ff22";
export var title = "index-module--title--e57db";
export var ulArea = "index-module--ulArea--870df";